// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-styles_title__md3t0 {
    color: var(--hightlight-color);
    margin: 50px auto 30px;
    font-size: 28px;
    font-weight: bold;
}

.login-styles_subtitle__svwII {
    color: #000;
    margin-bottom: 30px;
}

.login-styles_box__Rq9dX {
    padding: 40px 0;
    margin: 200px auto;
    width: 350px;
    max-width: 100%;
    text-align: center;
}

.login-styles_actions__9RT40 > * {
    width: 100%;
    margin-top: 25px;
}

.login-styles_loginActionOutlined__C0Xjs:hover,
.login-styles_loginAction__6vr74:hover {
    background-color: var(--primary-color-active);
    border-color: var(--primary-color-active);
    color: #fff;
}

.login-styles_error__2hQaB {
    border: 1px solid var(--dark-grey);
    padding: 20px 16px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    color: var(--alert-color);
    margin: 30px 0 32px;
    font-size: 16px;
    line-height: 20px;
}

.login-styles_error__2hQaB span {
    display: block;
    margin: auto 0 auto 16px;
    text-align: left;
}

.login-styles_errorBtn__fxVQD {
    color: var(--alert-color);
    padding: 0px;
    border: 0;
    background: transparent;
    margin: 0 16px 0 0;
    width: 34px;
    height: 34px;
}

.login-styles_errorBtn__fxVQD svg {
    width: 98%;
    height: auto;
}

.login-styles_input__Mz3UJ {
    border: 1px solid var(--dark-grey);
    padding: 12px 16px;
    border-radius: 5px;
    background: #fff;
    font-size: 16px;
}

.login-styles_label__bKMXx {
    position: relative;
    margin-bottom: 20px;
}

.login-styles_placeholder__Fe\\+jA {
    position: absolute;
    color: var(--dark-grey);
    font-size: 16px;
    display: block;
    top: 50%;
    left: 20px;
    background: #fff;
    transform: translateY(-50%);
    transform-origin: left top;
    transition:
        top 0.4s,
        transform 0.4s;
    padding: 0 2px;
}

.login-styles_input__Mz3UJ:focus + .login-styles_placeholder__Fe\\+jA,
.login-styles_input__Mz3UJ:not(:placeholder-shown) + .login-styles_placeholder__Fe\\+jA {
    top: 4px;
    transform: translateY(-50%) scale(0.8);
}

@media (max-height: 1100px) {
    .login-styles_box__Rq9dX {
        margin: auto;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/login-styles.module.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,6CAA6C;IAC7C,yCAAyC;IACzC,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,2BAA2B;IAC3B,0BAA0B;IAC1B;;sBAEkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,QAAQ;IACR,sCAAsC;AAC1C;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":[".title {\n    color: var(--hightlight-color);\n    margin: 50px auto 30px;\n    font-size: 28px;\n    font-weight: bold;\n}\n\n.subtitle {\n    color: #000;\n    margin-bottom: 30px;\n}\n\n.box {\n    padding: 40px 0;\n    margin: 200px auto;\n    width: 350px;\n    max-width: 100%;\n    text-align: center;\n}\n\n.actions > * {\n    width: 100%;\n    margin-top: 25px;\n}\n\n.loginActionOutlined:hover,\n.loginAction:hover {\n    background-color: var(--primary-color-active);\n    border-color: var(--primary-color-active);\n    color: #fff;\n}\n\n.error {\n    border: 1px solid var(--dark-grey);\n    padding: 20px 16px;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    color: var(--alert-color);\n    margin: 30px 0 32px;\n    font-size: 16px;\n    line-height: 20px;\n}\n\n.error span {\n    display: block;\n    margin: auto 0 auto 16px;\n    text-align: left;\n}\n\n.errorBtn {\n    color: var(--alert-color);\n    padding: 0px;\n    border: 0;\n    background: transparent;\n    margin: 0 16px 0 0;\n    width: 34px;\n    height: 34px;\n}\n\n.errorBtn svg {\n    width: 98%;\n    height: auto;\n}\n\n.input {\n    border: 1px solid var(--dark-grey);\n    padding: 12px 16px;\n    border-radius: 5px;\n    background: #fff;\n    font-size: 16px;\n}\n\n.label {\n    position: relative;\n    margin-bottom: 20px;\n}\n\n.placeholder {\n    position: absolute;\n    color: var(--dark-grey);\n    font-size: 16px;\n    display: block;\n    top: 50%;\n    left: 20px;\n    background: #fff;\n    transform: translateY(-50%);\n    transform-origin: left top;\n    transition:\n        top 0.4s,\n        transform 0.4s;\n    padding: 0 2px;\n}\n\n.input:focus + .placeholder,\n.input:not(:placeholder-shown) + .placeholder {\n    top: 4px;\n    transform: translateY(-50%) scale(0.8);\n}\n\n@media (max-height: 1100px) {\n    .box {\n        margin: auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `login-styles_title__md3t0`,
	"subtitle": `login-styles_subtitle__svwII`,
	"box": `login-styles_box__Rq9dX`,
	"actions": `login-styles_actions__9RT40`,
	"loginActionOutlined": `login-styles_loginActionOutlined__C0Xjs`,
	"loginAction": `login-styles_loginAction__6vr74`,
	"error": `login-styles_error__2hQaB`,
	"errorBtn": `login-styles_errorBtn__fxVQD`,
	"input": `login-styles_input__Mz3UJ`,
	"label": `login-styles_label__bKMXx`,
	"placeholder": `login-styles_placeholder__Fe+jA`
};
export default ___CSS_LOADER_EXPORT___;
